import DataTable from 'src/shared/components/table';
import TableColumns from './columns';
import useTableV2 from 'src/shared/hooks/useTableV2';
import {ICampaignCustomer} from 'src/shared/services/campaigns/dto/campaign-list';
import {useParams} from 'react-router-dom';
import {useGetCampaignCustomers} from '../../hooks/useGetCampaignCustomers';

function EmailAddress() {
  const {id} = useParams();
  const {showTotal, ...tableV2} = useTableV2();
  const {data, isLoading} = useGetCampaignCustomers(id ?? '');

  return (
    <DataTable
      columns={TableColumns()}
      dataSource={data?.Data}
      rowKey={(record: ICampaignCustomer) => record?.Email?.toString()}
      loading={isLoading}
      border
      tableProps={tableV2}
    />
  );
}

export default EmailAddress;
